import { TextButton } from '@wix/design-system';
import { parseDomain } from '@wix/domains-serverless-interface';
import React from 'react';
import { MobileStatusBox } from './MobileStatusBox';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
export const MobilePurchaseRootRequired = _ref => {
  let domainName = _ref.domainName,
    action = _ref.action,
    datahook = _ref.datahook;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    Trans = _DomainSearchGateModu.Trans;
  const _parseDomain = parseDomain(domainName ?? ''),
    main = _parseDomain.main;
  const _parseDomain2 = parseDomain(main),
    formattedInput = _parseDomain2.formattedInput;
  return /*#__PURE__*/React.createElement(MobileStatusBox, {
    datahook: datahook
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.mobile.error.subdomain",
    values: {
      domainName: formattedInput
    },
    components: [/*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      weight: "thin",
      underline: "always",
      onClick: action
    })]
  }));
};
//# sourceMappingURL=MobilePurchaseRootRequired.js.map